import React from 'react';
import { BuildPath } from  '@/helpers/Paths';
import "../../../../css/global/brandLogo.scss";


const BrandLogo = ({imageUrl, altText, className}: {imageUrl: string, altText: string, className?: string}) => {

    return (
        <div className={`brand-logo ${className}`}>
            {imageUrl 
                ?   <img src={imageUrl} alt={altText} onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => { const target = e.target as HTMLImageElement; target.src =  `${BuildPath()}/images/logos/152x152.png`; }} />
                :   <img src={`${BuildPath()}/images/logos/152x152.png`} />
            }        
        </div>
    )
}

export default BrandLogo;